// extracted by mini-css-extract-plugin
export default {"input-label":"styles_input-label__zQ9NI"};